import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './shared/services';
import { HomeComponent } from './pages/home/home.component';
import { DxButtonModule, DxDataGridModule, DxDateBoxModule, DxFormModule, DxLoadPanelModule } from 'devextreme-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SurveyLayoutComponent } from './layouts/survey-layout/survey-layout.component';

const SurveyRoutes: Routes = [
  {
    path: 'survey01',
    loadChildren: () => import('./survey-list/survey01/survey01.module').then(m => m.Survey01Module)
  },
  {
    path: 'survey02',
    loadChildren: () => import('./survey-list/survey02/survey02.module').then(m => m.Survey02Module)
  },
  {
    path: 'survey03',
    loadChildren: () => import('./survey-list/survey03/survey03.module').then(m => m.Survey03Module)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

const routes: Routes = [
  { path: '', component: SurveyLayoutComponent, children: SurveyRoutes },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), DxDataGridModule, DxFormModule, DxButtonModule, DxDateBoxModule, FlexLayoutModule, 
    CommonModule, MatButtonModule, DxLoadPanelModule],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [
    HomeComponent
  ]
})
export class AppRoutingModule { }
